<template>
  <div>
    <div class="vh-100">
      <iframe style="height: 100vh; width: 100%" src="https://www.youtube.com/embed/1J2DGD0IJV8?controls=1&autoplay=1&cc_load_policy=1&mute=1" title="YouTube video player" autoplay frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  computed: {},
};
</script>

<style>
body,
html {
  height: 100%;
}

#app.player-margin {
 margin-bottom: 0 !important   
}

#app .navbar {
    display: none !important;
}
</style>